import Vue from 'vue'
import Router from 'vue-router'
import { Form } from 'vant'

Vue.use(Router)

//首页
const Home = r => require.ensure([], () => r(require('@/pages/Home')), 'Home')
//政策查询
const Policy = r => require.ensure([], () => r(require('@/pages/Policy')), 'Policy')
// 政策匹配
const Rapid = r => require.ensure([], () => r(require('@/pages/Rapid')), 'Rapid')
// 政策匹配结果
const Result = r => require.ensure([], () => r(require('@/pagesSub/Rapid/Result')), 'Result')
// 政策日历
const Calendar = r => require.ensure([], () => r(require('@/pagesSub/Home/calendar/Calendar')), 'Calendar')
// 政策日历查询列表
const List = r => require.ensure([], () => r(require('@/pagesSub/Home/calendar/List')), 'List')
// 通知页面
const Notice = r => require.ensure([], () => r(require('@/pagesSub/Home/notice/Notice')), 'Notice')
// 通知详情
const NoticeDetail = r => require.ensure([], () => r(require('@/pagesSub/Home/notice/NoticeDetail')), 'NoticeDetail')

// 政策法规固定详情 -- 龙岗产服（lgis）
const LgisDetail = r => require.ensure([], () => r(require('@/pagesSub/Home/notice/otherDetail/lgisDetail')), 'LgisDetail')

// 政策详情
const Detail = r => require.ensure([], () => r(require('@/pagesSub/Rapid/Detail')), 'Detail')
const DetailFiles = r => require.ensure([], () => r(require('@/pagesSub/Rapid/DetailFiles')), 'DetailFiles')
// 登录
const Login = r => require.ensure([], () => r(require('@/pagesSub/Login/Login')), 'Login')
//注册
const Register = r => require.ensure([], () => r(require('@/pagesSub/Login/Register')), 'Register')
const FirstRePwd = r => require.ensure([], () => r(require('@/pagesSub/Forgetpwd/FirstRePwd')), 'FirstRePwd')
const TwoRePwd = r => require.ensure([], () => r(require('@/pagesSub/Forgetpwd/TwoRePwd')), 'TwoRePwd')
//用户协议
const Proxy = r => require.ensure([], () => r(require('@/pagesSub/Login/Proxy')), 'Proxy')
// 政策解读
const Interpretation = r => require.ensure([], () => r(require('@/pagesSub/Home/interpretation/Interpretation')), 'Interpretation')
// 404
const Error404 = r => require.ensure([], () => r(require('@/pagesSub/error/404')), 'Error404')

// lgis(国高育成)
const lgisPolicy = () => import('@/pagesSub/dingzhi/lgis/policy')
const lgisResult = () => import('@/pagesSub/dingzhi/lgis/result')
const lgisCalendarList = () => import('@/pagesSub/dingzhi/lgis/calendarList')

const routes = [
  {
    path: '/:name/:appid',
    name: 'Home',
    component: Home,
    meta: {
      title: '政策一站享'
    }
  },
  {
    path: '/Policy',
    name: 'Policy',
    component: Policy,
    meta: {
      nkey: 'PolicyList',
      keepAlive: true,
      isBack: false,  //用于判断上一个页面是哪个
      title: '政策查询'
    },
  },
  {
    path: '/Rapid',
    name: 'Rapid',
    component: Rapid,
    meta: {
      title: '政策匹配',
      requireAuth: true
    }
  },
  {
    path: '/Result',
    name: 'Result',
    component: Result,
    meta: {
      nkey: 'ResultList',
      keepAlive: true,
      // requireAuth: true,
      title: '匹配结果'
    }
  },
  {
    path: '/Calendar',
    name: 'Calendar',
    component: Calendar,
    meta: {
      title: '政策日历'
    }
  },
  {
    path: '/List',
    name: 'List',
    component: List,
    meta: {
      nkey: 'CalendarList',
      keepAlive: true,
      isBack: false,  //用于判断上一个页面是哪个
      title: '政策日历'
    },
  },
  {
    path: '/Notice',
    name: 'Notice',
    component: Notice,
    meta: {
      nkey: 'NoticeList',
      keepAlive: true,
      isBack: false,  //用于判断上一个页面是哪个
    },
  },
  {
    path: '/NoticeDetail',
    name: 'NoticeDetail',
    component: NoticeDetail,
    meta: {
      nkey: 'NoticeDetail',
      title: '通知详情'
    }
  },
  {
    path: '/LgisDetail',
    name: 'lgisDetail',
    component: LgisDetail,
    meta: {
      nkey: 'LgisDetail',
      title: '通知详情'
    }
  },
  {
    path: '/Detail',
    name: 'Detail',
    component: Detail,
    meta: {
      nkey: 'PolicyDetail',
      title: '项目详情'
    }
  },
  {
    path: '/DetailFiles',
    name: 'DetailFiles',
    component: DetailFiles,
    meta: {
      nkey: 'DetailFiles',
      title: '项目详情'
    }
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/Register',
    name: 'Register',
    component: Register,
    meta: {
      title: '注册'
    }
  },
  {
    path: '/FirstRePwd',
    name: 'FirstRePwd',
    component: FirstRePwd,
    meta: {
      title: '找回密码'
    }
  },
  {
    path: '/TwoRePwd',
    name: 'TwoRePwd',
    component: TwoRePwd,
    meta: {
      title: '找回密码'
    }
  },
  {
    path: '/Proxy',
    name: 'Proxy',
    component: Proxy,
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/Interpretation',
    name: 'Interpretation',
    component: Interpretation,
    meta: {
      title: '政策解读'
    }
  },
  {
    path: '/404',
    name: 'Error404',
    component: Error404,
    meta: {
      title: '404'
    }
  },
  {
    path: '/lgisPolicy',
    name: 'lgisPolicy',
    component: lgisPolicy,
    meta: {
      nkey: 'lgisPolicyList',
      keepAlive: true,
      isBack: false,  //用于判断上一个页面是哪个
      title: '政策查询'
    },
  },
  {
    path: '/lgisResult',
    name: 'lgisResult',
    component: lgisResult,
    meta: {
      nkey: 'lgisResult',
      keepAlive: true,
      // requireAuth: true,
      title: '匹配结果'
    },
  },
  {
    path: '/lgisList',
    name: 'lgisCalendarList',
    component: lgisCalendarList,
    meta: {
      nkey: 'lgisCalendarList',
      keepAlive: true,
      isBack: false,  //用于判断上一个页面是哪个
      title: '政策日历'
    },
  },
]

const navigationToFrom = [
  { to: 'PolicyList', from: 'PolicyDetail' },
  { to: 'NoticeList', from: 'NoticeDetail' },
  { to: 'CalendarList', from: 'PolicyDetail' },
  { to: 'ResultList', from: 'PolicyDetail' },
  { to: 'PolicyDetail', from: 'DetailFiles' },  
  { to: 'lgisPolicyList', from: 'PolicyDetail' },
  { to: 'lgisResult', from: 'PolicyDetail' },
  { to: 'lgisCalendarList', from: 'PolicyDetail' },
]

const router = new Router({
  mode: 'history',
  routes
})

var store = {
  debug: true,
  state: {
    keepAlive: [] //需要缓存的组件名称（对应路由的name）
  },
  addKeepAlive(keepAlive_) { //将name新增到keepAlive数组（name存在不操作）
    let isExist = false
    for (let i = 0; i < this.state.keepAlive.length; i++) {
      if (this.state.keepAlive[i] == keepAlive_) {
        isExist = true
      }
    }
    if (!isExist) {
      this.state.keepAlive.push(keepAlive_)
    }
  },
  clearKeepAlive(keepAlive_) { //从keepAlive数组中移除指定name（name不存在不操作）
    let index = -1
    for (let i = 0; i < this.state.keepAlive.length; i++) {
      if (this.state.keepAlive[i] == keepAlive_) {
        index = i
        break
      }
    }
    if (index > -1) {
      this.state.keepAlive.splice(index, 1)
    }
  },
  setKeepAlive(keepAliveArr_) { //重新赋值keepAlive数组
    this.state.keepAlive = keepAliveArr_
  },
  getKeepAlive() { //获取keepAlive数组
    return this.state.keepAlive
  }
}
Vue.prototype.vstore = store

router.beforeEach((to, from, next) => {
  //判断下一个页面(to)是否需要缓存(to.meta.keepAlive属性指定)
  if (to.meta != null) {
    if (to.meta.keepAlive == true) {
      store.addKeepAlive(to.name)
    }
  }

  //判断离开的页面是否需要清除缓存，当页面离开时，进入的不是下级页面，就需要将当前页面对应的缓存移除
  if (from.meta != null) {
    //获取当前页面对应的缓存，得到缓存数组对应的下标index
    let keepAliveArr = store.getKeepAlive()
    let index = -1
    for (let i = 0; i < keepAliveArr.length; i++) {
      if (keepAliveArr[i] == from.name) {
        index = i
        break
      }
    }
    if (index > -1) { //大于-1表示页面被缓存了
      //判断下次进入的页面是否为下级页面
      let isExist = false
      if (to.meta != null) {
        for (let j = 0; j < navigationToFrom.length; j++) {
          if (navigationToFrom[j].to == from.meta.nkey && navigationToFrom[j].from == to.meta.nkey) {
            isExist = true
          }
        }
      }
      //不是下级页面，删除当前页面对应的缓存
      if (!isExist) {
        store.clearKeepAlive(keepAliveArr[index])
      }
    }
  }
  next()
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js